import { render, staticRenderFns } from "./details.vue?vue&type=template&id=39c2ff6f&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=39c2ff6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c2ff6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c2ff6f')) {
      api.createRecord('39c2ff6f', component.options)
    } else {
      api.reload('39c2ff6f', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=39c2ff6f&scoped=true&", function () {
      api.rerender('39c2ff6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/sharing_list/details/details.vue"
export default component.exports